import { render, staticRenderFns } from "./task-change-owner.vue?vue&type=template&id=430a2994&"
import script from "./task-change-owner.vue?vue&type=script&lang=js&"
export * from "./task-change-owner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports